import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountSettingsService {
  updatePassword$ = new Subject<string>();

  constructor() {}
}
